import {TypeOf} from 'io-ts';
import {BaseCurrencyCode} from './BaseCurrencyCode';

export const TokenBlockchainCryptoCurrencyCode = BaseCurrencyCode;
export type TokenBlockchainCryptoCurrencyCode = TypeOf<typeof TokenBlockchainCryptoCurrencyCode>;
